import React, { useState, useEffect } from "react";
import "./addsupplier.css";
// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { addSupplier } from "../../../../../services/warehouse.services";
// library imports
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useTranslation } from "react-i18next";

const AddSupplier = ({ open, setOpen, setSnack, setRefresh }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    website: "",
    email: "",
    phone: "",
  });

  const handelChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (formData.name === "") {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("suppliers.pleaseEnterSupplierName"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }
    if (formData.address === "") {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("suppliers.pleaseEnterSupplierAddress"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }
    if (formData.email === "") {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("suppliers.pleaseEnterSupplierEmail"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }
    if (formData.website === "") {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("suppliers.pleaseEnterSupplierWebsite"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }
    if (formData.phone === "") {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("suppliers.pleaseEnterSupplierPhone"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }

    const response = await addSupplier(formData);
    // console.log("response", response.data.result);
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text:
            response?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setLoading(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("suppliers.supplierAddedSuccessfully"),
          severity: "success",
        };
      });
      setRefresh(Math.floor(Math.random() * 100) + 1);
      setLoading(false);
      setFormData({ name: "", address: "", website: "", email: "", phone: "" });
      setOpen(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen()}
        aria-labelledby="add-currency-modal-title"
        aria-describedby="add-currency-modal-description"
      >
        <div className="addsupplier__modal_wrap">
          <div className="addsupplier__header">
            <h3 className="addsupplier__title">{t("suppliers.addSupplier")}</h3>
          </div>
          <div className="addsupplier__body">
            <div className="addsupplier__inputwrapper">
              <FormControl variant="outlined" className="w-100">
                <InputLabel htmlFor="addCategoryName" size="small">
                  {t("suppliers.name")}
                </InputLabel>
                <OutlinedInput
                  id="addCategoryName"
                  name="name"
                  value={formData.name}
                  size="small"
                  onChange={(e) => handelChange(e)}
                  label={t("suppliers.supplierName")}
                />
              </FormControl>
              <FormControl variant="outlined" className="w-100">
                <InputLabel htmlFor="addCategoryName" size="small">
                  {t("suppliers.address")}
                </InputLabel>
                <OutlinedInput
                  id="addCategoryName"
                  name="address"
                  value={formData?.address}
                  size="small"
                  onChange={(e) => handelChange(e)}
                  label={t("suppliers.supplierAddress")}
                />
              </FormControl>
            </div>
            <div className="addsupplier__inputwrapper">
              <FormControl variant="outlined" className="w-100">
                <InputLabel htmlFor="addCategoryName" size="small">
                  {t("suppliers.website")}
                </InputLabel>
                <OutlinedInput
                  id="addCategoryName"
                  name="website"
                  value={formData?.website}
                  size="small"
                  onChange={(e) => handelChange(e)}
                  label={t("suppliers.supplierWebsite")}
                />
              </FormControl>
              <FormControl variant="outlined" className="w-100">
                <InputLabel htmlFor="addCategoryName" size="small">
                  {t("suppliers.email")}
                </InputLabel>
                <OutlinedInput
                  id="addCategoryName"
                  name="email"
                  value={formData?.email}
                  size="small"
                  onChange={(e) => handelChange(e)}
                  label={t("suppliers.supplierEmail")}
                />
              </FormControl>
            </div>
            <div className="addsupplier__inputwrapper">
              <FormControl variant="outlined" className="w-100">
                <InputLabel htmlFor="addCategoryName" size="small">
                  {t("suppliers.phone")}
                </InputLabel>
                <OutlinedInput
                  id="addCategoryName"
                  name="phone"
                  value={formData?.phone}
                  size="small"
                  onChange={(e) => handelChange(e)}
                  label={t("suppliers.supplierPhone")}
                />
              </FormControl>
            </div>
          </div>
          <div className="addsupplier__modalfooter">
            <div
              className="addsupplier__modalreset"
              onClick={() => setOpen(false)}
            >
              {t("common:actions.cancel")}
            </div>
            <div className="addsupplier__modalsubmit" onClick={handleSubmit}>
              {loading ? <Loader /> : t("common:actions.save")}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddSupplier;
